export enum TestIds {
  AttachFiles = 'attachFiles',
  Contributors = 'contributors',
  DateRaised = 'dateRaised',
  Departments = 'departments',
  Description = 'description',
  Owners = 'owners',
  Priority = 'priority',
  Status = 'status',
  Tags = 'tags',
  Title = 'title',
}
